/* HIRA MODA – Sprachabhaengige Produktbilder nach Dateiname (_DE/_ENG/_AR).
   Wirkt UEBERALL: jede Seite, jeder Slider, jede Kachel. Zeigt je aktiver Shop-
   Sprache nur die passenden Bilder; Bilder OHNE Kennung bleiben immer sichtbar.
   Wichtig: _DE/_ENG/_AR nur als Sprachkennung im Dateinamen verwenden. */
(function(){
  if (document.getElementById('hiramoda-lang-filter')) return;
  // Bekannte Slide-/Kachel-Huellen: ganze Kachel ausblenden (kein leerer Platzhalter)
  var box = '.product__media-item,.thumbnail-list__item,.card-swipe__slide';
  // Welche Sprache blendet welche Fremd-Kennungen aus
  var map = { de: ['eng','ar'], en: ['de','ar'], ar: ['de','eng'] };
  var parts = [];
  Object.keys(map).forEach(function(lang){
    map[lang].forEach(function(tag){
      var imgs = "img[src*='_"+tag+".' i], img[src*='_"+tag+"_' i]";
      // 1) bekannte Huelle komplett einklappen
      parts.push("html[lang^='"+lang+"'] :is("+box+"):has("+imgs+")");
      // 2) ueberall sonst: das Bild selbst ausblenden
      parts.push("html[lang^='"+lang+"'] img[src*='_"+tag+".' i]");
      parts.push("html[lang^='"+lang+"'] img[src*='_"+tag+"_' i]");
    });
  });
  var css = parts.join(', ') + ' { display: none !important; }';
  var s = document.createElement('style');
  s.id = 'hiramoda-lang-filter';
  s.appendChild(document.createTextNode(css));
  (document.head || document.documentElement).appendChild(s);
})();

/* HIRA MODA – Slider sprachabhaengig: statt das deutsche Slider-Bild in EN/AR
   auszublenden, laedt der Slider das Bild der aktiven Sprache (Dateiname-Tausch
   _DE -> _ENG/_AR, Desktop + Mobil). Betrifft NUR die Slideshow-Slides. */
(function(){
  function lang(){ return (document.documentElement.getAttribute('lang') || 'de').slice(0,2).toLowerCase(); }
  function tok(l){ return l === 'en' ? 'ENG' : (l === 'ar' ? 'AR' : 'DE'); }
  function swap(){
    var t = tok(lang());
    var imgs = document.querySelectorAll('.slideshow__slide img');
    for (var i = 0; i < imgs.length; i++){
      var im = imgs[i];
      ['src','srcset'].forEach(function(attr){
        var v = im.getAttribute(attr);
        if (!v) return;
        var nv = v
          .split('_DE.').join('_'+t+'.').split('_de.').join('_'+t+'.')
          .split('_ENG.').join('_'+t+'.').split('_eng.').join('_'+t+'.')
          .split('_AR.').join('_'+t+'.').split('_ar.').join('_'+t+'.');
        if (nv !== v) im.setAttribute(attr, nv);
      });
    }
  }
  if (document.readyState !== 'loading'){ swap(); } else { document.addEventListener('DOMContentLoaded', swap); }
})();

/* HIRA MODA – Bild-Banner-Section auf Produktseiten ausblenden (alle Sprachen).
   Wirkt nur auf Produktseiten; blendet die komplette image-banner-Section
   inkl. Abstand aus. Sprachunabhaengig (gilt fuer de/en/ar). */
(function(){
  if (!document.querySelector('.product__info-container')) return;
  if (document.getElementById('hira-hide-banner')) return;
  var s = document.createElement('style');
  s.id = 'hira-hide-banner';
  s.textContent = '[id^="shopify-section"]:has(.banner-section-image){display:none !important;}';
  (document.head || document.documentElement).appendChild(s);
})();
